<template>
    <div
      class="modal right fade trader-info"
      id="trader-info"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"       
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" >{{ bidwanted.cusip }} FAILED LOGS</h5>
            <button type="button" class="close"  @click="$emit('close')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="modal-body">
              <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
              <table class="table align-items-center table-flush table-hover bidtbl">
                <thead class="thead-light psticky">
                  <tr>
                    <th scope="col"  class="sort text-center">Date</th>
                    <th scope="col"  class="sort text-center">TRADER </th>
                    <th scope="col"  class="sort text-center">suggested Price</th>
                    <th scope="col"  class="sort text-center">calculated Yield </th>
                    <th scope="col"  class="sort text-center">idc Failure Reason </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="history.length == 0 && !loading">
                      <td><p class="nodata">No data available</p>
                      </td>
                  </tr>
                  <tr v-for="(data,index) in history" :key="index">
                    <td class="text-center">{{moment.utc(data.createdAt).local().format("MM/DD/YYYY hh:mm:ss a")}}</td>
                    <td class="text-center">{{data.firstName}} {{data.lastName}}</td>
                    <td class="text-center">{{data.suggestedPrice | currency}}</td>
                    <td class="text-center text-wrap">{{data.calculatedYield}}</td>
                    <td class="text-center text-wrap">{{data.idcFailureReason}}</td>
                    
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import authService from "@/authService";
import config from "@/config";
export default {
      name: 'notehistory',
      components :{
          
      },
      props: ['bidwanted'],
      data() {
          return {
              loading : false,
              history : [],
             
          };
      },
      methods: { 
        getHistory(){
            this.loading = true;
            const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            this.$http
            .get(
              config.baseUrlAutoBidder +
                "/autobidder/failed-logs?autoBidBwId="+this.bidwanted.id,
                auth
            )
            .then(result => {
              this.history = result.data.reverse();
              this.loading = false;
            })
          },
      },
      created(){
        this.getHistory()
      }
  };
  </script>